import React, { createContext, useContext } from 'react';

export const DataContext = createContext(
  undefined
);

export const PageContextProvider = ({ children, value }) => {
  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useDataContext must be used within a PageContextProvider');
  }
  return context;
};

export default DataContext;
